import CryptoJS from "../../node_modules/crypto-js";
/**
 * 
 * 第一个参数word是待加密或者解密的字符串；
 * 第二个参数keyStr是aes加密需要用到的16位字符串的key；
 * 
 * 如果想对一个js对象加密，需要先把该对象转成json字符串。 
 */
export default {
  // 加密
  encrypt(word, keyStr) {
    keyStr = keyStr ? keyStr : "7SO9ry1Hx8fLcgA2";
    let key = CryptoJS.enc.Utf8.parse(keyStr);
    let srcs = CryptoJS.enc.Utf8.parse(word);
    let encrypted = CryptoJS.AES.encrypt(srcs, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
  },
  // 解密
  decrypt(word, keyStr) {
    keyStr = keyStr ? keyStr : "7SO9ry1Hx8fLcgA2";
    var key = CryptoJS.enc.Utf8.parse(keyStr);
    var decrypt = CryptoJS.AES.decrypt(word, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });

    returnData = CryptoJS.enc.Utf8.stringify(decrypt).toString();
    console.log(returnData);
    return returnData;
  }
};



// WEBPACK FOOTER //
// ./src/utils/AES-ECB.js